import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectorRef, ViewChild } from '@angular/core';
import {DocumentService} from '../../../services/document.service';
import {LoadingController} from '@ionic/angular';
import {PacientService} from '../../../services/pacient.service';

@Component({
    selector: 'app-exame-detalhe-component',
    templateUrl: 'exame-detalhe-component.html',
    styleUrls: ['./exame-detalhe-component.scss']
})

export class ExameDetalheComponent implements OnInit {
    list: any;
    userFiltro: any;

    @Input() exame: any;
    @Output() exameVoltar = new EventEmitter();

    constructor(
        private document: DocumentService,
        private pacient: PacientService,
        private loadingCtrl: LoadingController
    ) {
    }

    async ngOnInit() {
        this.userFiltro = await this.pacient.getInfo();
        await this.getDetalhe();
    }

    async voltar() {
        this.exameVoltar.emit();
    }

    async getDetalhe() {
        const loading = await this.loadingCtrl.create();
        await loading.present();
        this.list = await this.document.loadDetail(this.exame);
        await loading.dismiss();
    }
}
